// src/lib/crypto.utils.ts
import CryptoJS from 'crypto-js';

/**
 * Clave de cifrado para sessionStorage
 * En producción, usar variable de entorno
 */
const STORAGE_SECRET = process.env.NEXT_PUBLIC_STORAGE_SECRET || 'default-storage-secret-key-change-in-prod';

/**
 * Cifra datos para almacenamiento en sessionStorage
 * Usa AES-256 para cifrado simétrico
 */
export function encryptStorage(data: string): string {
    try {
        return CryptoJS.AES.encrypt(data, STORAGE_SECRET).toString();
    } catch (error) {
        console.error('Error encrypting storage data:', error);
        throw error;
    }
}

/**
 * Descifra datos desde sessionStorage
 * Retorna string vacío si falla el descifrado (datos corruptos o clave incorrecta)
 */
export function decryptStorage(encryptedData: string): string {
    try {
        const bytes = CryptoJS.AES.decrypt(encryptedData, STORAGE_SECRET);
        const decrypted = bytes.toString(CryptoJS.enc.Utf8);
        
        if (!decrypted) {
            throw new Error('Decryption failed - invalid data or key');
        }
        
        return decrypted;
    } catch (error) {
        console.error('Error decrypting storage data:', error);
        throw error;
    }
}